import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: 'https://gnews.io/api/v4/top-headlines'
  })
}
